export class User {
  accessToken: string;
  expiredDate: Date;
  expiresIn: number;
  id: number;
  name: string;
  clientId: number;
  tableCartId: number;

  constructor(id: number, accessToken: string, expiresIn: number, name: string, clientId?: number, tableCartId?: number,expiredDate?: Date) {
    this.id = id;
    this.accessToken = accessToken;
    this.expiredDate = expiredDate ?? new Date(new Date().getTime() + (1000 * expiresIn));
    this.expiresIn = expiresIn;
    this.name = name;
    this.clientId = clientId ?? 0;
    this.tableCartId = tableCartId ?? 0;
  }

  setExpiredDate(expiredDate:Date) {
    this.expiredDate = expiredDate;
  }

  isExpired() {
    const now = new Date();
    const expireDate = new Date(this.expiredDate);

    return now.getTime() >= expireDate.getTime();
  }
}